import { SingleUser } from '../users/singleUser';

export type SingleDepartment = {
	accountId: string;
	deptId: string;
	name: string;
	description: string;
	uiColor: string;
	createdAt: string;
	updatedAt: string;
	numbersCount: number;
	usersCount: number;
	managers: string[] | SingleUser[];
};

const model: types.models.InputModel = {
	accountId: 'accountId',
	deptId: 'deptId',
	name: 'name',
	description: 'description',
	uiColor: 'uiColor',
	createdAt: 'createdAt',
	updatedAt: 'updatedAt',
	numbersCount: 'numbersCount',
	usersCount: 'usersCount',
	managers: 'managers',
};

export default model;
